// client/src/components/DIVERS/RedirectionAbonnement.js
// Page de redirection silencieuse : /redirectionabonnement/:code? → /merchantofferselection/:code?
// Redirection des liens Affilates

// eslint-disable-next-line
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { sanitize } from '../../utils/sanitize';

const RedirectionAbonnement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { code: rawCode } = useParams();

  useEffect(() => {
    const cleanCode = rawCode ? sanitize(rawCode) : '';
    const targetPath = cleanCode
      ? `/merchantofferselection/${encodeURIComponent(cleanCode)}`
      : '/merchantofferselection';

    // Conserve éventuels query params/hash pour ne rien perdre lors de la redirection.
    navigate(`${targetPath}${location.search}${location.hash}`, { replace: true });
  }, [navigate, rawCode, location.search, location.hash]);

  return null;
};

export default RedirectionAbonnement;
